export default {
    version: 'v1.9',// 版本号
    apiTimeout: 15000,
    lang: 'zh',// zh 中文 en 英文
    appId: '8000418004',// 应用id,不需要修改
    baseUrl: 'http://39.99.149.198:8009/',
}
